export default "__VITE_ASSET__CDNcNjCG__"